module.exports = __webpack_public_path__ + "img/allergen-free.da11676a.png";